import { useEffect } from 'react'
import { useSEOTags } from '../hooks/useSEOTags'

const SEOMetaTags = ({ title, description: customDescription, keywords: customKeywords }) => {
  const { generateMetaTags } = useSEOTags()

  useEffect(() => {
    try {
      const metaTags = generateMetaTags()
      
      // Mevcut meta tag'leri temizle
      const existingMetaTags = document.querySelectorAll('meta[name="keywords"], meta[name="description"]')
      existingMetaTags.forEach(tag => tag.remove())

      // Keywords meta tag'i ekle
      if (metaTags.keywords || customKeywords) {
        const keywordsMeta = document.createElement('meta')
        keywordsMeta.name = 'keywords'
        keywordsMeta.content = customKeywords || metaTags.keywords
        document.head.appendChild(keywordsMeta)
      }

      // Description meta tag'i ekle
      if (metaTags.description || customDescription) {
        const descriptionMeta = document.createElement('meta')
        descriptionMeta.name = 'description'
        descriptionMeta.content = customDescription || metaTags.description
        document.head.appendChild(descriptionMeta)
      }

      // Title güncelle
      if (title) {
        document.title = title
      }

      // JSON-LD structured data ekle
      const existingJsonLd = document.querySelector('script[type="application/ld+json"]')
      if (existingJsonLd) {
        existingJsonLd.remove()
      }

      if (metaTags.tags && metaTags.tags.length > 0) {
        const jsonLd = {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Buğra Teknik Servis",
          "description": customDescription || metaTags.description,
          "keywords": customKeywords || metaTags.keywords,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Şirinevler Mahalesi Bestekar Sokak No-20",
            "addressLocality": "Karabük",
            "addressRegion": "Karabük",
            "addressCountry": "TR"
          },
          "telephone": "+905334287027",
          "email": "ramazanbasol74@gmail.com",
          "url": window.location.origin,
          "sameAs": [
            "https://www.instagram.com/bugrateknikservis"
          ],
          "openingHours": "Mo-Su 09:00-21:00",
          "priceRange": "$$",
          "serviceArea": {
            "@type": "City",
            "name": "Karabük"
          }
        }

        const script = document.createElement('script')
        script.type = 'application/ld+json'
        script.textContent = JSON.stringify(jsonLd)
        document.head.appendChild(script)
      }

      // Cleanup function
      return () => {
        const addedMetaTags = document.querySelectorAll('meta[name="keywords"], meta[name="description"]')
        addedMetaTags.forEach(tag => tag.remove())
      }
    } catch (error) {
      console.error('SEO Meta Tags error:', error)
    }
  }, [generateMetaTags, title, customDescription, customKeywords])

  return null
}

export default SEOMetaTags
